function endpoint(base, path) {
  return `${base.replace(/\/$/, '')}/${path.replace(/^\//, '')}`;
}

async function request(base, path, options = {}) {
  const response = await fetch(endpoint(base, path), {
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
    ...options,
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(payload.detail || payload.error || `Request failed (${response.status})`);
    error.status = response.status;
    error.payload = payload;
    throw error;
  }
  return payload;
}

export function getCatalog(base) {
  return request(base, 'catalog/products/');
}

export function getPublishedContent(base) {
  return request(base, 'site/media/');
}

export function getPaymentConfiguration(base) {
  return request(base, 'payments/config/');
}

export function getQuote(base, items) {
  return request(base, 'checkout/quote/', {
    method: 'POST',
    body: JSON.stringify({ items }),
  });
}

export function createCheckout(base, form, items) {
  return request(base, 'checkout/orders/', {
    method: 'POST',
    headers: { 'Idempotency-Key': crypto.randomUUID() },
    body: JSON.stringify({ ...form, items }),
  });
}

export function contentMap(blocks) {
  return Object.fromEntries((Array.isArray(blocks) ? blocks : []).map((block) => [block.key, block]));
}
